/**
 * TDS (Tax Deducted at Source) API Endpoints
 * Framework-agnostic endpoint definitions for TDS module
 */

export const TDS_ENDPOINTS = {
  /** Get all TDS uploads list */
  list: 'tds/get-tds-file',

  /** Upload TDS zip file */
  upload: 'tds/tds-zipfile-upload',

  /** Unzip uploaded TDS file */
  unzip: 'tds/tds-upload-unzip',

  /** Get unzipped TDS Excel file */
  getExcel: 'tds/get-tds-unzip',
} as const;
